<template>
  <b-overlay :show="loading" opacity="0.5">
    <div>
      <list-table
        :records="partnerOptions" 
        :columns="tableColumns"
        :show-import-button="false"
        :total-records="totalRecords"
        :search-filter.sync="searchFilter"
        search-place-holder="Search Disease"
        :current-page-number.sync="currentPage"
        :show-export-button="can('partners:CanExport')"
      >
      </list-table>
    </div>
  </b-overlay>
</template>
  
<script>
import {
  BOverlay, BCard, BRow, BCol, BAlert, BLink, BTable,
  BMedia, BAvatar, BButton, BFormFile,
  BBadge, BDropdown, BDropdownItem, BPagination,
  BInputGroup, BInputGroupAppend, BFormInput
} from 'bootstrap-vue'

// import { get, debounce, cloneDeep } from "lodash"

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
// import FileDownload from "js-file-download";

import ListTable from "@/@core/components/ListTable/ListTable.vue";
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const watchHandler = {
  handler(){
    this.debouncedFetchUsersData()
  }, 
  immediate: false
}
  
const watchHandlerAndResetPageNumber = {
  handler(){
    this.currentPage = 1
    this.debouncedFetchUsersData()
  }, 
  immediate: false
}
  
export default {
  components: {
    ListTable,

    BOverlay,
    BCard,
    BTable,
    BRow,
    BCol,
    BAlert,
    BBadge,
    BLink,
    BMedia,
    BAvatar,
    BButton,
    BDropdown,
    BFormFile,
    BFormInput,
    BPagination,
    BInputGroup, 
    BDropdownItem,
    BInputGroupAppend, 

    vSelect,
  },
  directives: {
    Ripple,
  },
  data(){
    return {
      loading: false,
      showFilter: false,
      isAddOrUpdateModalToggle: false,

      searchFilter: null,
      editingData: null,

      partnerOptions: [
        { partner: 'Ahotopa Comfort', value: 'ahotopa_comfort' },
        { partner: 'Ahotopa with MTN', value: 'ahotopa_with_mtn' },
        { partner: 'Premier Health', value: 'premier_health' },
        { partner: 'Teledokta', value: 'teledokta' },
      ],

      partners: [],
      
      tableColumns: [
        { key: 'partner', label: 'Partner', sortable: false },
      ],
      debouncedFetchUsersData: () => {}
    }
  },
  computed: {
    perPage: {
      get() {
        return this.$store.getters[`navigation/recordsPerPage`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_RECORDS_PER_PAGE`, value)
      }
    },
    currentPage: {
      get() {
        return this.$store.getters[`navigation/currentPage`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_CURRENT_PAGE_NUMBER`, value)
      }
    },
    totalRecords: {
      get(){
        return this.$store.getters[`navigation/totalRecords`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_TOTAL_RECORDS`, value)
      }
    },
  },
  watch: {
    perPage: {
      handler(){
        this.currentPage = 1;
        this.debouncedFetchUsersData()
      }, 
      immediate: false
    },
    currentPage: watchHandler,
    searchFilter: watchHandlerAndResetPageNumber,
  },
  // created(){
  //   this.debouncedFetchUsersData = debounce(this.fetchAllData, 500);
  //   this.fetchAllData()

  //   const { 
  //     page = 1, 
  //     search = "", 
  //     limit = this.perPage 
  //   } = this.$route.query;

  //   this.currentPage = +page;
  //   this.searchFilter = search;
  //   this.perPage = +limit;
  // },
  methods: {
    // async fetchAllData() {
    //   try {
    //     this.loading = true; 

    //     const query = {
    //       limit: this.perPage,
    //       page: this.currentPage,
    //       search: this.searchFilter,
    //     }
    //     this.$router.push({ query }).catch(() => {});

    //     const request = await this.useJwt().mainService.patients.list(query);
    //     const { data, pagination } = request.data;

    //     this.totalRecords = pagination.totalRecords
    //     this.perPage = pagination.limit;
    //     this.partners = data;
    //   } catch (error) {
    //     const error_message = get(error, "response.data.message") || error.message
    //     console.log("error_message", error_message)
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Error!',
    //         icon: 'AlertTriangleIcon',
    //         variant: 'danger',
    //         text: error_message
    //       },
    //     });
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // async onExport(){
    //   try {
    //     this.loading = true;

    //     const result = await this.$swal({
    //       title: 'Confirm Export?',
    //       text: "This will export data based on current filters.",
    //       icon: 'warning',
    //       showCancelButton: true,
    //       confirmButtonText: 'Yes, proceed.',
    //       customClass: {
    //         confirmButton: 'btn btn-primary',
    //         cancelButton: 'btn btn-outline-danger ml-1',
    //       },
    //       buttonsStyling: false,
    //     });

    //     if (!result.value) {
    //       return;
    //     }

    //     const query = {
    //       search: this.searchFilter,
    //     }

    //     const response = await this.useJwt().mainService.commonComplaints.export(query);
    //     FileDownload(response.data, "common-complaints.csv");
    //   } catch (error) {
    //     const error_message = get(error, "response.statusText") || error.message;

    //     this.$nextTick(() => {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: 'Error!',
    //           icon: 'AlertTriangleIcon',
    //           variant: 'danger',
    //           text: error_message
    //         },
    //       });
    //     })
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // async onDelete(updating_data){
    //   try {
    //     this.loading = true;

    //     const result = await this.$swal({
    //       title: "Caution!!!",
    //       text: `Proceed to delete this common complaint?`,
    //       icon: "question",
    //       showCancelButton: true,
    //       confirmButtonText: 'Yes',
    //       customClass: {
    //         confirmButton: 'btn btn-primary',
    //         cancelButton: 'btn btn-outline-danger ml-1',
    //       },
    //       buttonsStyling: false,
    //     });

    //     if (!result.isConfirmed) {
    //       return;
    //     }

    //     await this.useJwt().mainService.commonComplaints.delete(updating_data.id);
    //     this.fetchAllData();

    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Success!',
    //         icon: 'CheckCircleIcon',
    //         variant: 'success',
    //         text: `Common complaint deleted successfully`
    //       },
    //     });
    //   } catch (error){
    //     const error_message = get(error, "response.data.message") || error.message
    //     this.errorMessage = error_message;

    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Error!',
    //         icon: 'AlertTriangleIcon',
    //         variant: 'danger',
    //         text: error_message
    //       },
    //     });
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // onAddNew(){
    //   this.editingData = null;
    //   this.isAddOrUpdateModalToggle = true;
    // },
    // onEdit(updating_data){
    //   this.editingData = cloneDeep(updating_data);
    //   this.isAddOrUpdateModalToggle = true;
    // },
    
  }
}
</script>
  
<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-select.scss';
  .width-100 {
    width: 100px;
  }
  .per-page-selector {
    width: 90px;
  }
</style>
  
<style lang="scss">
  .loan-list-tb-row {
    cursor: pointer !important;
  }
</style>
